import { Button, Phone16 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAgentAvailability, getPhones, getVillageId, selectOffer, selectUser } from '../../../../selectors';
import { getDynamicCalltrackingSiteBlockId } from '../../../../selectors/getDynamicCalltrackingSiteBlockId';
import { isRenterFormEnabled } from '../../../../selectors/isRenterFormEnabled';
import { getRosreestrInfo } from '../../../../selectors/offerData/getRosreestrInfo';
import { selectAgent } from '../../../../selectors/selectAgent';
import { prefetchFormState } from '../../../../store/deal-rent';
import { setPhoneCollapse } from '../../../../store/phone_collapse';
import { SimpleBotDetector } from '../../../../utils/simpleBotDetector';
import { useApplicationContext } from '../../../ApplicationContext';
import { trackShowPhoneClick } from '../../../AsideContacts/tracking';
import { OpenPhoneContainer } from './OpenPhoneContainer';

export const CallButtonContainer: React.FC = () => {
  const [isPhonesOpened, setPhonesOpened] = React.useState(false);

  const dispatch = useDispatch();
  const { logger } = useApplicationContext();

  const offer = useSelector(selectOffer);
  const phones = useSelector(getPhones);
  const isDealRentFormEnabled = useSelector(isRenterFormEnabled);
  const agent = useSelector(selectAgent);
  const agentAvailability = useSelector(getAgentAvailability);
  const user = useSelector(selectUser);
  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const rosreestrInfo = useSelector(getRosreestrInfo);
  const villageId = useSelector(getVillageId);

  const onShowPhoneClick = () => {
    if (isDealRentFormEnabled) {
      dispatch(prefetchFormState());

      return;
    }

    setPhonesOpened(true);
    dispatch(setPhoneCollapse());
  };

  const trackShowPhone = () => {
    const botDetector = new SimpleBotDetector();
    const isAgentNotAvailable = agentAvailability && !agentAvailability.available;

    trackShowPhoneClick({
      offer,
      agent,
      user,
      kpId: villageId,
      bot: !botDetector.isHuman(),
      isAgentNotAvailable,
      siteBlockId,
      rosreestrInfo,
    });
  };

  const handleCallButton: VoidFunction = () => {
    trackShowPhone();
    onShowPhoneClick();
  };

  if (!phones.length || phones.some(phone => !phone.countryCode || !phone.number)) {
    logger.error(`Offer #${offer.cianId}: phones is null`);

    return null;
  }

  return (
    <div>
      {isPhonesOpened && <OpenPhoneContainer />}
      {!isPhonesOpened && (
        <Button
          theme="fill_secondary"
          size="XS"
          beforeIcon={<Phone16 color="primary_100" />}
          onClick={handleCallButton}
        />
      )}
    </div>
  );
};
